<template>
  <qx-card title="列表">
    <LogRightDialog
      ref="logRightDialog"
      busiCode="400000"
    />
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
          >
            <section  slot-scope="scope">
              <section v-if="scope.column.property === 'loginAcct'" @click="toDetail(scope.row)">
                <span class="primary cur">{{scope.row[scope.column.property]}}</span>
              </section>
              <section
                v-if="scope.column.property !== 'loginAcct'"
              >{{scope.row[scope.column.property]}}</section>
            </section>
          </el-table-column>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column prop="control" label="操作" width="160">
            <template slot-scope="scope">
              <section>
                <!-- 操作按钮 -->
                <qx-permpisions permpisions="">
                  <span class="primary cur" @click="showLog(scope.row.relId)">日志</span>
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import {
  servicerRecordList,
} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'loginAcct',
            label: '服务商账号',
          },
          {
            prop: 'serviceName',
            label: '服务商名称',
          },
          {
            prop: 'companyAddress',
            label: '公司地址',
          },
          {
            prop: 'linkman',
            label: '联系人',
          },
          {
            prop: 'serviceTypeName',
            label: '服务商类型',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: servicerRecordList,
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核服务商' : '服务商详情',
        url: `/manage/service/merchant/manage/detail?id=${item.serviceUserId}&relId=${item.relId}&type=${type}`,
        full: true,
      });
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
